/* eslint-disable */

import Moment from "moment";
import Swal from "sweetalert2";
import {
  BIKES,
  DATE_FORMAT_DEFAULT,
  STATIONS,
  VIRTUAL_STATION,
} from "../constants/const";
import {
  FILTER_BY_CITY_ID,
  FILTER_BY_TAG,
  STATION_STATUSES,
  STATION_TYPES,
} from "../constants/filterConst";
import {
  bigIssueTheme,
  farteTheme,
  gjovikTheme,
  mobyTheme,
  sefaTheme,
  shareBikeTheme,
  shematicTheme,
  sigoTheme,
  weelzTheme,
} from "../constants/WhiteLabelTheme";
import { strings } from "../I18n";
import bigissueLogo from "../images/bigissueLogo.png";
import farteBriskkel from "../images/FarteBysykkel.png";
import gjovikLogo from "../images/gjovikLogo.png";
import mobyLogo from "../images/mobyLogo.png";
import sefaLogo from "../images/sefaLogo.png";
import shareBikeLogo from "../images/shareBikeLogo.png";
import sigoLogo from "../images/sigo-logo.svg";
import weelzLogo from "../images/weelzLogo.png";
import { store } from "../store";
import { isDevEnvironment } from "./environment";

export const reformatSort = (sortData) => {
  if (sortData?.column) {
    return `${sortData.column.selector},${sortData.sortDirection}`;
  } else {
    return "";
  }
};
export const reformatFilter = (filterData) => {
  let builder = "&";
  filterData?.forEach((value) => {
    let filterValue = value.filter;
    if (value.filterBy === "duration" && value.filter) {
      filterValue = String(parseInt(value.filter) * 60);
    }
    builder += `${value.filterBy}=${filterValue}&`;
  });
  return builder.slice(0, -1);
};

export const reformatSearch = (oSearchData, searchText) => {
  const searchData = [];
  if (oSearchData) {
    searchData.push(oSearchData);
  }

  if ((searchData?.length === 0 || !searchData) && searchText) {
    return `&search=${searchText}`;
  } else if (searchData?.length > 0 && searchText) {
    let builder = "&";
    searchData?.forEach((value) => {
      builder += `${value.value}=${searchText}&`;
    });
    return builder.slice(0, -1);
  } else {
    return "";
  }
};

export const stringByStatus = (status) =>
  status ? strings("descriptions.yes") : strings("descriptions.no");

export const generateEndpoint = (
  endpoint,
  page = 0,
  search = "",
  sort = "",
  filter = ""
) => {
  filter = filter && filter[0] === "&" ? filter.slice(1) : filter;
  endpoint += `&page=${page}`;
  endpoint += search !== "" ? `&search=${search}` : search;
  endpoint += sort !== "" ? `&sort=${sort}` : sort;
  endpoint += filter !== "" ? `&${filter}` : filter;
  return endpoint;
};
export const generateEndpointWithSearchFilter = (
  endpoint,
  page = 0,
  search = "",
  sort = "",
  filter = ""
) => {
  filter = filter && filter[0] === "&" ? filter.slice(1) : filter;
  endpoint += `&page=${page}`;
  endpoint += sort !== "" ? `&sort=${sort}` : sort;
  endpoint += filter !== "" ? `&${filter}` : filter;
  endpoint += search !== "" ? search : "";
  return endpoint;
};

export const generateCustomEndpoint = (
  endpoint,
  page = 0,
  search = "",
  cityId = "",
  sort = "",
  filter = "",
  size = "",
  userId = "",
  startDate = "",
  endDate = "",
  couponId = ""
) => {
  let builder = "";
  builder += endpoint;
  builder += `page=${page}`;
  builder += `&size=${size}`;
  if (search) builder += `&search=${search}`;
  if (cityId) builder += `&cityId=${cityId}`;
  if (sort && sort !== "null") builder += `&sort=${sort}`;
  if (userId) builder += `&userId=${userId}`;
  if (startDate) builder += `&startDate=${startDate}`;
  if (endDate && !String(endDate).includes("null"))
    builder += `&endDate=${endDate}`;
  if (couponId) builder += `&couponId=${couponId}`;
  if (filter) builder += `&${filter}`;
  return builder;
};

export const generateCustomEndpointWithSearch = (
  endpoint,
  page = 0,
  search = "",
  cityId = "",
  sort = "",
  filter = "",
  size = "",
  userId = "",
  startDate = "",
  endDate = "",
  couponId = ""
) => {
  let builder = "";
  builder += endpoint;
  builder += `page=${page}`;
  builder += `&size=${size}`;
  if (cityId) builder += `&cityId=${cityId}`;
  if (sort && sort !== "null") builder += `&sort=${sort}`;
  if (userId) builder += `&userId=${userId}`;
  if (startDate) builder += `&startDate=${startDate}`;
  if (endDate && !String(endDate).includes("null"))
    builder += `&endDate=${endDate}`;
  if (couponId) builder += `&couponId=${couponId}`;
  if (filter) builder += filter;
  if (search) builder += search;
  return builder;
};

export const generateMapEndpoind = (
  url,
  typeFilter = [],
  stationType = [],
  stationState = [],
  bikeState = [],
  city = null
) => {
  let result = "";
  if (typeFilter.length) {
    result = "?";
  } else {
    if (city) {
      return `${url}?${city}`;
    }
    return url;
  }
  typeFilter.map((type, index) => {
    result += !index
      ? `${type.toLowerCase()}=true`
      : `&${type.toLowerCase()}=true`;
    return type;
  });

  let stationStatuses = "";
  if (stationType.length && typeFilter.includes(STATIONS)) {
    stationStatuses = `&${STATION_TYPES}`;

    stationType.map((type, index) => {
      stationStatuses += !index ? type : `,${type}`;
      return type;
    });
  }

  let stationTypes = "";
  if (stationState.length && typeFilter.includes(STATIONS)) {
    stationTypes = `&${STATION_STATUSES}`;

    stationState.map((state, index) => {
      stationTypes += !index ? state : `,${state}`;
      return state;
    });
  }

  let otherStatuses = "";
  if (bikeState.length && typeFilter.includes(BIKES)) {
    bikeState.map((status) => {
      const values = status.split(" ").map((item, index) => {
        let newItem = item;
        if (index) {
          newItem = newItem[0].toUpperCase() + newItem.substr(1);
        } else {
          newItem = newItem[0].toLowerCase() + newItem.substr(1);
        }
        return newItem;
      });
      otherStatuses += `&${values.join("")}=true`;
      return status;
    });
  }

  result += stationStatuses + stationTypes + otherStatuses;

  if (city) {
    result += `${result.length ? "&" : ""}${city}`;
  }

  return url + result;
};

export const stringFromValue = (value) => (value != null ? value : "N/A");

export const formatPhoneNumber = (phone) => {
  if (!phone) return null;
  const cleaned = String(phone).replace(/\s/g, "");

  if (cleaned.startsWith("+")) {
    const afterPlus = cleaned.slice(1);
    const ccLength =
      afterPlus.startsWith("1") && afterPlus.length >= 11 ? 1 : 2;
    const countryCode = "+" + afterPlus.slice(0, ccLength);
    const rest = afterPlus.slice(ccLength);
    const groups = rest.match(/.{1,3}/g) || [];
    return `${countryCode} ${groups.join(" ")}`;
  }

  const groups = cleaned.match(/.{1,3}/g) || [];
  return groups.join(" ");
};
export const removeUnderscoreGetString = (value) => value.replace(/_/g, " ");
export const sortedItem = (index, orderKey, orderProps) => ({
  index,
  orderKey,
  orderProps,
});

export const filterUrl = (filter, cities) => {
  let filterUrl = "";
  if (filter === null) {
    return "";
  }
  filter.map((item) => {
    if (item.filterBy === FILTER_BY_TAG) {
      return item;
    }
    if (filterUrl !== "") filterUrl += "&";
    filterUrl += `${item.filterBy}=${showFilter(item.filterBy, item.filter, cities)}`;
    return item;
  });
  return filterUrl;
};

export const showFilter = (filterBy, filter, items) => {
  switch (filterBy) {
    case FILTER_BY_CITY_ID: {
      const city = items.filter((item) => item.name === filter)[0];
      return city?.id;
    }
    default:
      return filter;
  }
};

export const cityNameById = (citiesList, id) =>
  id ? citiesList.filter((item) => item.id === id)[0]?.name : null;

export const filterByValue = (filterBy) => {
  if (filterBy === FILTER_BY_CITY_ID) {
    return strings("descriptions.city");
  } else if (filterBy === FILTER_BY_TAG) {
    return "Tag";
  } else {
    return filterBy;
  }
};

export const secondsToMin = (seconds) => {
  if (seconds) {
    if (seconds < 3600) {
      return Moment.utc(seconds * 1000).format("mm:ss");
    } else {
      const hour =
        Math.floor(Moment.duration(seconds, "seconds").asHours()) < 10
          ? "0" + Math.floor(Moment.duration(seconds, "seconds").asHours())
          : Math.floor(Moment.duration(seconds, "seconds").asHours());
      const minute =
        Moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + Moment.duration(seconds, "seconds").minutes()
          : Moment.duration(seconds, "seconds").minutes();
      const second =
        Moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + Moment.duration(seconds, "seconds").seconds()
          : Moment.duration(seconds, "seconds").seconds();
      return hour + ":" + minute + ":" + second;
    }
  }
  return "00:00";
};

const getCurrentGeometry = (geometry) => {
  return geometry.map((cordArr) => ({
    lat: cordArr[0],
    lng: cordArr[1],
  }));
};

export const generatePolygons = (array, maps, oldPolygons, action) => {
  let oldPolygonsArray = [];
  array.map((item) => {
    if (item.type === VIRTUAL_STATION && item?.geometry?.length) {
      const data = getCurrentGeometry(item.geometry);
      const geometry = new maps.Polygon({
        path: data,
        fillColor: "rgba(68,255,44,0.25)",
        strokeColor: "rgb(47,146,28)",
        strokeWeight: 2,
        cursor: "move",
      });
      oldPolygonsArray = [...oldPolygonsArray, geometry];
    }
    return null;
  });
  action(oldPolygonsArray);
};

export const WhitelabelCodeReturnDecide = (code, actions) => {
  switch (code) {
    case "moby":
      return actions[1];

    case "bigIssue":
      return actions[2];

    case "farteBysykkel":
      return actions[3];

    case "sigo":
      return actions[4];

    case "sefa":
      return actions[5];

    case "weelz":
      return actions[6];

    case "gjovik":
      return actions[7];

    default:
      return actions[0];
  }
};

export const getWhiteLabelLogo = (code) => {
  if (code === null && isDevEnvironment()) {
    return shareBikeLogo;
  }

  return WhitelabelCodeReturnDecide(code, [
    shareBikeLogo,
    mobyLogo,
    bigissueLogo,
    farteBriskkel,
    sigoLogo,
    sefaLogo,
    weelzLogo,
    gjovikLogo,
  ]);
};

export const isBigissue = (whiteLabelCode) => {
  return whiteLabelCode === "bigIssue";
};

const dateFormat = (date) => Moment(date + "Z").format("MMM D, YYYY HH:mm");

export const isSuperAdmin = (adminDetails) => {
  return adminDetails?.cityId === null && adminDetails?.whiteLabelId === null;
};
export const isSuperAdminOrCityAdmin = (adminDetails) => {
  return adminDetails?.cityId === null;
};

export const getWhiteLabelTheme = (whiteLabelCode) => {
  if (whiteLabelCode === null && isDevEnvironment()) {
    return shematicTheme;
  }
  return WhitelabelCodeReturnDecide(whiteLabelCode, [
    shareBikeTheme,
    mobyTheme,
    bigIssueTheme,
    farteTheme,
    sigoTheme,
    sefaTheme,
    weelzTheme,
    gjovikTheme,
  ]);
};

export const openNewTabMapMarker = (lat, lng) => {
  const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  const win = window.open(url, "_blank");
  if (win != null) {
    win.focus();
  }
};

export const constructImageDirectory = (baseDirectoryData) => {
  return `photo_finish/${baseDirectoryData?.cityCode?.toLowerCase()}/${baseDirectoryData?.pricingPlanType?.toLowerCase()}/${
    baseDirectoryData?.id
  }`;
};

export const convertDateToHumanReadableFormat = (date) => {
  return Moment(date).format("DD.MM.YYYY");
};

export const convertDateToUtc0InMilliseconds = (date) => {
  const dateUtc = Moment(date).utcOffset(0);
  dateUtc.add(12, "hour");
  return dateUtc.valueOf();
};

export const convertDateFromUtc0ToLocal = (date) => {
  return Moment.utc(date).local().format(DATE_FORMAT_DEFAULT);
};

export const remapArrayToValueAndLabel = (array) => {
  if (!array) return [];
  return array.map((item) => ({
    value: item.toString(),
    label: item.toString(),
  }));
};

export const modifyCurrencyToSymbol = (currencyName) => {
  const payment = store.getState().payment;
  const mappings = payment?.currencyMappings;

  const localMappings = [
    {
      code: "NOK",
      symbol: "kr",
      afterAmount: true,
    },
    {
      code: "SEK",
      symbol: "kr",
      afterAmount: true,
    },
    {
      code: "EUR",
      symbol: "€",
      afterAmount: false,
    },
    {
      code: "GBP",
      symbol: "£",
      afterAmount: false,
    },
    {
      code: "£",
      symbol: "£",
      afterAmount: false,
    },
    {
      code: "BSD",
      symbol: "B$",
      afterAmount: false,
    },
    {
      code: "FJD",
      symbol: "FJ$",
      afterAmount: false,
    },
    {
      code: "USD",
      symbol: "$",
      afterAmount: false,
    },
  ];

  const foundMapping = mappings?.find(
    (mapping) => mapping.code === currencyName
  );
  if (foundMapping) {
    return foundMapping.symbol;
  } else {
    const foundLocalMapping = localMappings.find(
      (mapping) => mapping.code === currencyName
    );
    if (foundLocalMapping) {
      return foundLocalMapping.symbol;
    } else {
      return currencyName;
    }
  }
};

export const modifyCurrencyToSymbolAndValue = (currencyName, price) => {
  if (price === null || price === undefined || Number.isNaN(price)) {
    return "-";
  }
  if (!currencyName) {
    return `${price}`;
  }
  const payment = store.getState().payment;
  const mappings = payment?.currencyMappings;
  const localMappings = [
    {
      code: "NOK",
      symbol: "kr",
      afterAmount: true,
    },
    {
      code: "SEK",
      symbol: "kr",
      afterAmount: true,
    },
    {
      code: "EUR",
      symbol: "€",
      afterAmount: false,
    },
    {
      code: "GBP",
      symbol: "£",
      afterAmount: false,
    },
    {
      code: "£",
      symbol: "£",
      afterAmount: false,
    },
    {
      code: "BSD",
      symbol: "B$",
      afterAmount: false,
    },
    {
      code: "FJD",
      symbol: "FJ$",
      afterAmount: false,
    },
    {
      code: "USD",
      symbol: "$",
      afterAmount: false,
    },
  ];

  const foundMapping = mappings?.find(
    (mapping) => mapping.code === currencyName
  );
  if (foundMapping) {
    return `${price} ${foundMapping.symbol}`;
  } else {
    const foundLocalMapping = localMappings.find(
      (mapping) => mapping.code === currencyName
    );
    if (foundLocalMapping) {
      return `${price} ${foundLocalMapping.symbol}`;
    } else {
      return `${price} ${currencyName}`;
    }
  }
};

export const formatCurrencyParts = (currencyName, price) => {
  if (price === null || price === undefined || Number.isNaN(price)) {
    return { value: "-", currency: "", formatted: "-" };
  }
  if (!currencyName) {
    return { value: String(price), currency: "", formatted: String(price) };
  }

  const payment = store.getState().payment;
  const mappings = payment?.currencyMappings;
  const localMappings = [
    { code: "NOK", symbol: "kr", afterAmount: true },
    { code: "SEK", symbol: "kr", afterAmount: true },
    { code: "EUR", symbol: "€", afterAmount: false },
    { code: "GBP", symbol: "£", afterAmount: false },
    { code: "£", symbol: "£", afterAmount: false },
    { code: "BSD", symbol: "B$", afterAmount: false },
    { code: "FJD", symbol: "FJ$", afterAmount: false },
    { code: "USD", symbol: "$", afterAmount: false },
  ];

  const foundMapping =
    mappings?.find((mapping) => mapping.code === currencyName) ||
    localMappings.find((mapping) => mapping.code === currencyName);

  const symbol = foundMapping?.symbol || currencyName;
  const formatted = `${price} ${symbol}`;

  return {
    value: String(price),
    currency: symbol,
    formatted,
  };
};

export const sweetAlertConfirmDialog = (title, subTitle, confirm) => {
  Swal.fire({
    title: title,
    text: subTitle,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
    cancelButtonText: strings("message.cancel"),
    width: "400px",
  }).then((result) => {
    if (result.isConfirmed) {
      confirm();
    }
  });
};

export function isLocalHost(hostname = window.location.hostname) {
  return ["localhost", "127.0.0.1", "", "::1"].includes(hostname);
}

export const formatWhitelabelName = (name) => {
  if (!name) return name;

  const str = String(name).trim();
  if (!str) return str;

  const words = str.split(/[\s\-_]+/);

  return words
    .map((word) => {
      if (!word) return "";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" "); // Join with space for readable Pascal Case
};
